import { general } from './general'
import { motor } from './motor'
import { travel } from './travel'
import { pkg } from './package'
import { pa } from './pa'
import { fire } from './fire'
import { maid } from './maid'

export const getters = Object.assign({}, general, motor, travel, pkg, fire, maid, pa)
